// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var ViewStack = require("../../../reason/common/ViewStack.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Result = require("@rescript/core/src/Core__Result.bs.js");
var SystemMessage = require("../../../uikit/reason/molecules/SystemMessage/SystemMessage.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
var PropertyWizardFormRelay__Validators = require("./PropertyWizardFormRelay__Validators.bs.js");
var PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql = require("../../../__generated__/PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.bs.js");
var PropertyWizardRelayPreviewGlobalValidityIndicator_localDraft_graphql = require("../../../__generated__/PropertyWizardRelayPreviewGlobalValidityIndicator_localDraft_graphql.bs.js");

function PropertyWizardRelay__Preview__GlobalValidityIndicator$EditButton(props) {
  var onEditForm = props.onEditForm;
  return JsxRuntime.jsx(ButtonsV5.OutlineButton.make, {
              onClick: (function (param) {
                  onEditForm();
                }),
              disabled: props.disabled,
              children: "Continue editing"
            });
}

var EditButton = {
  make: PropertyWizardRelay__Preview__GlobalValidityIndicator$EditButton
};

function PropertyWizardRelay__Preview__GlobalValidityIndicator$EditAddressButton(props) {
  var onEditForm = props.onEditForm;
  return JsxRuntime.jsx(ButtonsV5.OutlineButton.make, {
              onClick: (function (param) {
                  onEditForm();
                }),
              disabled: props.disabled,
              children: "Edit address"
            });
}

var EditAddressButton = {
  make: PropertyWizardRelay__Preview__GlobalValidityIndicator$EditAddressButton
};

function PropertyWizardRelay__Preview__GlobalValidityIndicator$SubmitButton(props) {
  var onSubmit = props.onSubmit;
  var match = PropertyWizardFormRelay.Context.use();
  var tmp;
  var tmp$1 = match.mode;
  if (typeof tmp$1 !== "object") {
    tmp = "Broadcast";
  } else {
    switch (tmp$1.TAG) {
      case "Edit" :
          tmp = "Save Changes";
          break;
      case "Rebroadcast" :
          tmp = "Rebroadcast";
          break;
      case "BroadcastQuietSeller" :
          tmp = "Broadcast";
          break;
      
    }
  }
  return JsxRuntime.jsx(ButtonsV5.OutlineButton.make, {
              onClick: (function (param) {
                  onSubmit();
                }),
              disabled: props.disabled,
              children: Caml_option.some(tmp)
            });
}

var SubmitButton = {
  make: PropertyWizardRelay__Preview__GlobalValidityIndicator$SubmitButton
};

var convertFragment = PropertyWizardRelayPreviewGlobalValidityIndicator_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewGlobalValidityIndicator_localDraft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewGlobalValidityIndicator_localDraft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewGlobalValidityIndicator_localDraft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewGlobalValidityIndicator_localDraft_graphql.node, convertFragment, fRef);
}

var DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.node, convertFragment$1, fRef);
}

var FormStateFragment_localDraftAttachmentStatus_decode = PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.Utils.localDraftAttachmentStatus_decode;

var FormStateFragment_localDraftAttachmentStatus_fromString = PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.Utils.localDraftAttachmentStatus_fromString;

var FormStateFragment_localDraftGeocodingStatus_decode = PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.Utils.localDraftGeocodingStatus_decode;

var FormStateFragment_localDraftGeocodingStatus_fromString = PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.Utils.localDraftGeocodingStatus_fromString;

var FormStateFragment_localDraftSaveStatus_decode = PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.Utils.localDraftSaveStatus_decode;

var FormStateFragment_localDraftSaveStatus_fromString = PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.Utils.localDraftSaveStatus_fromString;

var FormStateFragment = {
  localDraftAttachmentStatus_decode: FormStateFragment_localDraftAttachmentStatus_decode,
  localDraftAttachmentStatus_fromString: FormStateFragment_localDraftAttachmentStatus_fromString,
  localDraftGeocodingStatus_decode: FormStateFragment_localDraftGeocodingStatus_decode,
  localDraftGeocodingStatus_fromString: FormStateFragment_localDraftGeocodingStatus_fromString,
  localDraftSaveStatus_decode: FormStateFragment_localDraftSaveStatus_decode,
  localDraftSaveStatus_fromString: FormStateFragment_localDraftSaveStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyWizardRelay__Preview__GlobalValidityIndicator(props) {
  var currentStep = props.currentStep;
  var onSubmit = props.onSubmit;
  var onEditForm = props.onEditForm;
  var formState = use$1(props.formState);
  var geocodingStatus = formState.geocodingStatus;
  var draftSaveStatus = formState.draftSaveStatus;
  var draft = use(props.draft);
  var formValid = PropertyWizardFormRelay__Validators.useIsFormValid(draft.fragmentRefs, formState.fragmentRefs);
  var formIsValid = Core__Result.isOk(formValid);
  var onEditForm$1 = function () {
    if (formValid.TAG === "Ok") {
      return onEditForm(currentStep);
    } else {
      return onEditForm(formValid._0);
    }
  };
  var draftSubmitting;
  switch (draftSaveStatus) {
    case "FirstSaveInProgress" :
    case "SaveInProgress" :
        draftSubmitting = true;
        break;
    default:
      draftSubmitting = false;
  }
  var submitting = draftSubmitting || props.isSubmittingForm;
  if (formState.filesStatus.length > 0 || formState.imagesStatus.length > 0) {
    return JsxRuntime.jsx(SystemMessage.make, {
                id: "previewPageMessage",
                text: "Your attachments are being uploaded. Please wait...",
                type_: "warning",
                icon: false,
                handleOnDismiss: (function (prim) {
                    
                  }),
                children: Caml_option.some(JsxRuntime.jsxs(ViewStack.make, {
                          space: "md",
                          flexDirection: "row",
                          children: [
                            JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator$EditButton, {
                                  onEditForm: onEditForm$1,
                                  disabled: submitting
                                }),
                            JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator$SubmitButton, {
                                  onSubmit: onSubmit,
                                  disabled: true
                                })
                          ]
                        }))
              });
  }
  if (geocodingStatus === "Called") {
    return JsxRuntime.jsx(SystemMessage.make, {
                id: "previewPageMessage",
                text: "The address is being validated. Please wait...",
                type_: "warning",
                icon: false,
                handleOnDismiss: (function (prim) {
                    
                  }),
                children: Caml_option.some(JsxRuntime.jsxs(ViewStack.make, {
                          space: "md",
                          flexDirection: "row",
                          children: [
                            JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator$EditButton, {
                                  onEditForm: onEditForm$1,
                                  disabled: submitting
                                }),
                            JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator$SubmitButton, {
                                  onSubmit: onSubmit,
                                  disabled: true
                                })
                          ]
                        }))
              });
  }
  if (geocodingStatus === "ErrorDuplicateListing") {
    return JsxRuntime.jsx(SystemMessage.make, {
                id: "previewPageMessage",
                text: "This property is already on TAN. Please go back and check the address.",
                type_: "error",
                icon: false,
                handleOnDismiss: (function (prim) {
                    
                  }),
                children: Caml_option.some(JsxRuntime.jsxs(ViewStack.make, {
                          space: "md",
                          flexDirection: "row",
                          children: [
                            JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator$EditAddressButton, {
                                  onEditForm: onEditForm$1,
                                  disabled: submitting
                                }),
                            JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator$SubmitButton, {
                                  onSubmit: onSubmit,
                                  disabled: true
                                })
                          ]
                        }))
              });
  }
  if (!formIsValid) {
    return JsxRuntime.jsx(SystemMessage.make, {
                id: "previewPageMessage",
                text: "The form is incomplete or has a validation error. Click edit or one of the missing fields to correct.",
                type_: "error",
                icon: true,
                handleOnDismiss: (function (prim) {
                    
                  }),
                children: Caml_option.some(JsxRuntime.jsxs(ViewStack.make, {
                          space: "md",
                          flexDirection: "row",
                          children: [
                            JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator$EditButton, {
                                  onEditForm: onEditForm$1,
                                  disabled: submitting
                                }),
                            JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator$SubmitButton, {
                                  onSubmit: onSubmit,
                                  disabled: true
                                })
                          ]
                        }))
              });
  }
  if (!formIsValid) {
    return null;
  }
  var tmp;
  switch (draftSaveStatus) {
    case "FirstSaveInProgress" :
    case "SaveInProgress" :
        tmp = "Preview. Your draft is being saved. Please wait...";
        break;
    case "NotSaved" :
    case "Saved" :
        tmp = "Preview";
        break;
    case "SaveFailed" :
        tmp = "Preview. Your draft could not be saved. You can continue editing but may lose progress";
        break;
    
  }
  return JsxRuntime.jsx(SystemMessage.make, {
              id: "previewPageMessage",
              text: tmp,
              type_: "warning",
              icon: true,
              handleOnDismiss: (function (prim) {
                  
                }),
              children: Caml_option.some(JsxRuntime.jsxs(ViewStack.make, {
                        space: "md",
                        flexDirection: "row",
                        children: [
                          JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator$EditButton, {
                                onEditForm: onEditForm$1,
                                disabled: submitting
                              }),
                          JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator$SubmitButton, {
                                onSubmit: onSubmit,
                                disabled: submitting
                              })
                        ]
                      }))
            });
}

var make = PropertyWizardRelay__Preview__GlobalValidityIndicator;

exports.EditButton = EditButton;
exports.EditAddressButton = EditAddressButton;
exports.SubmitButton = SubmitButton;
exports.DraftFragment = DraftFragment;
exports.FormStateFragment = FormStateFragment;
exports.make = make;
/* ButtonsV5 Not a pure module */
